<nav aria-label="breadcrumb" class="xng-breadcrumb-root" [ngClass]="class">
  <ol class="xng-breadcrumb-list">
    @for (
      breadcrumb of breadcrumbs$ | async;
      track $index; let isLast = $last; let isFirst = $first; let index = $index; let count = $count) {
      <li class="xng-breadcrumb-item">
        @if (!isLast) {
          <!--
            НАСТОЯЩАЯ ссылка (`routerLink` → атрибут `href`), а не click-only `role=button`.
            Крошки — основная структура внутренних ссылок «товар → категория → каталог»,
            и без `href` краулер её не видит вовсе: наверх по иерархии из карточки не ведёт
            ни одна ссылка, хотя JSON-LD BreadcrumbList рядом есть (он ссылкой не является).
            Проектное правило — CLAUDE.md: «plain click handlers without href aren't crawlable».

            `(click)` УБРАН намеренно: у `RouterLink` свой host-listener, и оставленный
            рядом обработчик дал бы вторую навигацию (та же ловушка описана в CLAUDE.md).
            Паритет поведения проверен в браузере: интерцептор пути применяется в `linkOf`,
            query/fragment — как раньше, через `useRouterLinkOnly`; отключённая крошка
            получает `null`-команды, поэтому не навигирует И не отдаёт href (прежний
            вариант её только аria-отключал, а клик всё равно уводил).
          -->
          <a
            [routerLink]="breadcrumb.disable ? null : linkOf(breadcrumb)"
            [queryParams]="breadcrumb.useRouterLinkOnly ? null : breadcrumb.queryParams"
            [fragment]="breadcrumb.useRouterLinkOnly ? undefined : breadcrumb.fragment"
            class="xng-breadcrumb-link"
            [ngClass]="{ 'xng-breadcrumb-link-disabled': breadcrumb.disable }"
            [attr.aria-disabled]="breadcrumb.disable"
            [attr.tabIndex]="breadcrumb.disable ? -1 : 0"
            >
            <ng-container *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: breadcrumb.label,
                info: breadcrumb.info,
                last: isLast,
                first: isFirst,
                index: index,
                count: count
              }
            "
           />
          @if (!itemTemplate) {
            {{
            breadcrumb.label
            }}
          }
        </a>
      }
      @if (isLast) {
        <label class="xng-breadcrumb-trail">
          <ng-container *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: breadcrumb.label,
                info: breadcrumb.info,
                last: isLast,
                first: isFirst,
                index: index,
                count: count
              }
            "
         />
        @if (!itemTemplate) {
          {{
          breadcrumb.label
          }}
        }
      </label>
    }
  </li>
  @if (!isLast) {
    <li
      class="xng-breadcrumb-separator"
      aria-hidden="true"
      role="separator"
      >
      <ng-container *ngTemplateOutlet="separatorTemplate" />
      @if (!separatorTemplate) {
        {{ separator }}
      }
    </li>
  }
}
</ol>
</nav>
